





















import { Vue, Prop, Component } from "vue-property-decorator"
import { VideoInfo } from "../../models/VideoInfo"
import VideoPlayer from "../shared/VideoPlayer.vue"
import IframeVideoPlayer from "../shared/IframeVideoPlayer.vue"
import "@/assets/fullVideoComponent.css"
import { SubtitleUrls } from "@/models/SubtitleUrls"
@Component({
  components: {
    VideoPlayer,
    IframeVideoPlayer
  }
})
export default class FullVideoComponent extends Vue {
  @Prop() fullvideo!: VideoInfo
  @Prop() gated!: boolean
  @Prop() showHead!: Boolean
  @Prop() duration!: string
  @Prop() subtitleUrls!: SubtitleUrls
  @Prop() subtitles!: SubtitleUrls[]
}
